import type { BundleItem, BundleItemOfType, BundlePayload, ChallengePayload } from './types';

export function isChallengeBundlePayload(payload: BundlePayload): payload is ChallengePayload {
  return payload.type === 'challenge';
}

export function isFreeSpinsBundleItem(
  item: BundleItem,
): item is BundleItemOfType<'freeSpins'> | BundleItemOfType<'minigameRound'> {
  return item.bundleType === 'freeSpins' || item.bundleType === 'minigameRound';
}

export function isCountDownBundleItem(item: BundleItem): item is BundleItemOfType<'countdown'> {
  return item.bundleType === 'countdown';
}

export function isMetaGameBundleItem(item: BundleItem): item is BundleItemOfType<'metagameToken'> {
  return item.bundleType === 'metagameToken';
}

export function isChallengeBundleItem(item: BundleItem): item is BundleItemOfType<'challenge'> {
  return item.bundleType === 'challenge';
}

export function isMetaGameFeatureBundleItem(item: BundleItem): item is BundleItemOfType<'metagameFeature'> {
  return item.bundleType === 'metagameFeature';
}

export function isSnappyGiftBundleItem(item: BundleItem): item is BundleItemOfType<'snappyGift'> {
  return item.bundleType === 'snappyGift';
}

export function isRoadPremiumLaneBundleItem(item: BundleItem): item is BundleItemOfType<'roadPremiumLane'> {
  return item.bundleType === 'roadPremiumLane';
}

export function isExtraOfferBundleItem(item: BundleItem): item is BundleItemOfType<'extra'> {
  return item.bundleType === 'extra';
}

export function isChallengeRewardBundleItem(item: BundleItem): item is BundleItemOfType<'challenge'> {
  return item.bundleType === 'challenge';
}
